// import { HStack, Text, View } from "native-base"
// import React, { RefObject, useImperativeHandle, useRef, useState } from "react"
// import { useAppContext } from "../../Universal/API/Context-API/AppContext"
// import { Pressable, StyleSheet, TouchableOpacity} from "react-native";
// import { Search } from "lucide-react-native";
// import TopButton from "./Buttons/TopButton";
// import MenuButton from "./Buttons/MenuButton";
// import SlideOutMenu, { hanldeSlideOutMenu, option } from "./SlideOutMenu/SlideOutMenu";
// import ImageWithAspectRatio from "../../Universal/Image/ImageWithAspectRatio";
// import { handleTopSlideOut } from "./TopSlideOut/TopSlideOut";
// import { PressableWrap } from "../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
// import SearchBarTop, { handleSearchBarTop } from "../../Universal/searchBars/SeacrhBarTop";
// import { NavigationHomeWithReset } from "../../Universal/API/API";
// import { isArray } from "lodash";
// import UserPriceSwitch from "../Components/Service/Account/Components/UserPriceSwitch";
// import ExpandedMenu from "./ExpandedMenu/ExpandedMenu";
// import  { handleExpandedMenu }from "./ExpandedMenu/utils";

// // somewhere in your app


// interface TopNavigatorProps{
//     navigation: any,
//     refSlideOutMenu: RefObject<hanldeSlideOutMenu>,
//     refTopSlideOut: RefObject<handleTopSlideOut>
//     options: option[]
// }
// export const heightOfTopNav = (isSmallVersion: boolean) => {
//     return  isSmallVersion ? 60 : 80
// }

// export interface handleTopNavigator {
//     buttonHovered:  () => {
//         [key: string]: boolean
//     }
// }
// const TopNavigator:React.FC<TopNavigatorProps> = React.forwardRef<handleTopNavigator, TopNavigatorProps>(({navigation, refSlideOutMenu, options},ref) => {
//     const {scaleAll, currentWidth, isMediumVersion ,isSmallVersion, USER} = useAppContext()
//     const [buttonHovered, setButtonHovered] = useState<{[key: string] : boolean}>({})

//     useImperativeHandle(ref, () => ({
//         buttonHovered: () => buttonHovered
//     }))

//     console.log('options', options)
//     const  refSearchBarTop = useRef<handleSearchBarTop>(null)

//     const refExpandedMenu = useRef<handleExpandedMenu>(null)
//     return (

//     <Pressable 
   
//     style = {{width: '100%', position: 'absolute', left: 0, top:0, height: heightOfTopNav(isSmallVersion), zIndex: 6, backgroundColor: '#F9F9F9', flexDirection: 'row', alignItems: 'center' }}>
//         <View style ={{width: 
//             ((isSmallVersion || isMediumVersion) ? 60 :  40 )* scaleAll, height: '100%'}}>
//             {isMediumVersion && <MenuButton 
//             size = {
//                 isMediumVersion ? 25 * scaleAll: 30 * scaleAll
//             }
//             onPress={() => {
//                 // navigation.openDrawer();
                
//                 refSlideOutMenu.current?.setDoAnimation(!refSlideOutMenu.current.getEnabled())
//                 }}/>}
//         </View>
        
//         {/* <YourComponent/> */}
//         <View style = {[(isSmallVersion || isMediumVersion) ? StyleSheet.absoluteFill : {},
//         (isSmallVersion || isMediumVersion)  ? {justifyContent: 'center', alignItems: 'center', zIndex: 1} : {}]} pointerEvents='box-none'>
//             <TouchableOpacity activeOpacity={0.7} onPress={() => {
//                 NavigationHomeWithReset({
//                     navigation, data: {}
//                 })
//             }}>
//                 <ImageWithAspectRatio 
//                     aspectRatio={216 / 83.869}
//                     minHeight={isMediumVersion ?  40 * scaleAll : (isSmallVersion)  ? 30  * scaleAll :  45  * scaleAll}
//                     source={{
//                         uri: require('./../../../assets/Images/logo_deante_big.png'),
//                         priority: 'high'
//                     } }
//                 />
               
//             </TouchableOpacity>
//              {
//                     USER && USER.access_token && 
//                     <HStack alignSelf={'center'} style={{gap: 10}} >
//                         <Text>РРЦ</Text>
//                         <UserPriceSwitch mode={'reverse'}/>
//                     </HStack>
//                 }
//         </View>
//         {!isMediumVersion && <>
//             <View style ={{
                
//                 // width:  currentWidth < 1590 ? 80 * scaleAll : 124 * scaleAll
//                 }}/> 
//                 {options && isArray(options) && options.map((button, id) => {
//                     return(
//                         <TopButton 
//                             key={button.text + '_' + id}
//                             scaleAll={scaleAll}
//                             minWidth = {
//                                     currentWidth < 1590 ? 200 : 232
//                                 }
//                             text={button.text} 
//                             onPress={() => {
//                                 if(button.onPress)
//                                     button.onPress(refExpandedMenu)
//                             }}
//                             onHoverIn={() => {
//                                 console.log(button.text)
//                                 setButtonHovered(prev => ({...prev, [button.text]: true}))
//                                 if(button.onHoverIn) button.onHoverIn(refExpandedMenu)}}
//                             onHoverOut={() => {
//                                 setButtonHovered(prev => ({...prev, [button.text]: false}))

//                                 if(button.onHoverOut) button.onHoverOut(refExpandedMenu)}}
//                         />
//                     )
//                 })}
//         </>}
        
//         <View style ={{flex: 1, flexDirection: 'row-reverse', marginRight: 40 * scaleAll}}>
//             <PressableWrap onPress={() => {refSearchBarTop.current?.enable()}}>
//                 <Search size={(isMediumVersion ? 22 : 25) * scaleAll}/>
//             </PressableWrap>
//         </View>
        
//         {/* Rolling SearchBarTop */}
//         {<SearchBarTop ref={refSearchBarTop} onClose={() => {}} navigation={navigation} 
//         callBackOnPress = {
//             () => {
//                 refExpandedMenu.current?.close()
//             }
//         } />}

//         {<SlideOutMenu options = {options} ref={refSlideOutMenu}/>}

//         <ExpandedMenu ref={refExpandedMenu}/>
//     </Pressable>
    
// )
// })







// export default React.memo(TopNavigator)


import { HStack, Text, View } from "native-base";
import React, { RefObject, useImperativeHandle, useRef, useState } from "react";
import { useAppContext } from "../../Universal/API/Context-API/AppContext";
import { Pressable, StyleSheet, TouchableOpacity } from "react-native";
import { Search } from "lucide-react-native";
import TopButton from "./Buttons/TopButton";
import MenuButton from "./Buttons/MenuButton";
import SlideOutMenu from "./SlideOutMenu/SlideOutMenu";
import type { hanldeSlideOutMenu, option } from "../Components/interfaces";
import ImageWithAspectRatio from "../../Universal/Image/ImageWithAspectRatio";
import { handleTopSlideOut } from "./TopSlideOut/TopSlideOut";
import { PressableWrap } from "../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import SearchBarTop, { handleSearchBarTop } from "../../Universal/searchBars/SeacrhBarTop";
import { NavigationHomeWithReset } from "../../Universal/API/API";
import { isArray } from "lodash";
import UserPriceSwitch from "../Components/Service/Account/Components/UserPriceSwitch";
import ExpandedMenu from "./ExpandedMenu/ExpandedMenu";
import { handleExpandedMenu } from "./ExpandedMenu/utils";

interface TopNavigatorProps {
  navigation: any;
  refSlideOutMenu: RefObject<hanldeSlideOutMenu>;
  refTopSlideOut?: RefObject<handleTopSlideOut>;
  options: option[];
  menuBarHover: {
    onHoverIn: () => void;
    onHoverOut: (refExpandedMenu: RefObject<handleExpandedMenu | null>) => void;
  };
  setServiceMobile?: (x: null | option[]) => any
}

export const heightOfTopNav = (isSmallVersion: boolean) => {
  return isSmallVersion ? 60 : 80;
};

export interface handleTopNavigator {
  buttonHovered: () => {
    [key: string]: boolean;
  };
}

const TopNavigator: React.FC<TopNavigatorProps> = React.forwardRef<
  handleTopNavigator,
  TopNavigatorProps
>(({ navigation, refSlideOutMenu, options, menuBarHover, setServiceMobile }, ref) => {
  const { scaleAll, currentWidth, isMediumVersion, isSmallVersion, isIOS, isWeb, USER } = useAppContext();
  const [buttonHovered, setButtonHovered] = useState<{ [key: string]: boolean }>({});

  useImperativeHandle(ref, () => ({
    buttonHovered: () => buttonHovered,
  }));

  const refSearchBarTop = useRef<handleSearchBarTop>(null);

  const refExpandedMenu = useRef<handleExpandedMenu>(null);
  const isMobileWeb = isWeb && currentWidth <= 430;
  const logoMinHeight =
    isSmallVersion && (isIOS || isMobileWeb)
      ? Math.max(42, 40 * scaleAll)
      : isMediumVersion
        ? 40 * scaleAll
        : isSmallVersion
          ? 30 * scaleAll
          : 45 * scaleAll;

  return (
    <Pressable
      onHoverIn={menuBarHover.onHoverIn}
      onHoverOut={() => menuBarHover.onHoverOut(refExpandedMenu)}
      style={{
        width: "100%",
        position: "absolute",
        left: 0,
        top: 0,
        height: heightOfTopNav(isSmallVersion),
        zIndex: 6,
        backgroundColor: "#F9F9F9",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <View
        style={{
          width: (isSmallVersion || isMediumVersion ? 60 : 40) * scaleAll,
          height: "100%",
        }}
      >
        {isMediumVersion && (
          <MenuButton
            size={isMediumVersion ? 25 * scaleAll : 30 * scaleAll}
            onPress={() => {
              refSlideOutMenu.current?.setDoAnimation(!refSlideOutMenu.current.getEnabled());
            }}
          />
        )}
      </View>

      <View
        style={[
          (isSmallVersion || isMediumVersion) ? StyleSheet.absoluteFill : {},
          (isSmallVersion || isMediumVersion)
            ? { justifyContent: "center", alignItems: "center", zIndex: 1 }
            : {},
        ]}
        pointerEvents="box-none"
      >
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => {
            NavigationHomeWithReset({ navigation, data: {} });
          }}
        >
          <ImageWithAspectRatio
            aspectRatio={216 / 83.869}
            minHeight={logoMinHeight}
            source={{
              uri: require("./../../../assets/Images/logo_deante_big.png"),
              priority: "high",
            }}
          />
        </TouchableOpacity>

        {USER && USER.access_token && (
          <HStack alignSelf={"center"} style={{ gap: 10 }}>
            <Text>РРЦ</Text>
            <UserPriceSwitch mode={"reverse"} />
          </HStack>
        )}
      </View>

      {!isMediumVersion && (
        <>
          <View style={{}} />
          {options &&
            isArray(options) &&
            options.map((button, id) => {
              return (
                <TopButton
                  key={button.text + "_" + id}
                  minWidth={currentWidth < 1590 ? 200 : 232}
                  text={button.text}
                  onPress={() => {
                    if (button.onPress) button.onPress(refExpandedMenu);
                  }}
                  onHoverIn={() => {
                    setButtonHovered((prev) => ({ ...prev, [button.text]: true }));
                    // ❗️тут можно оставить визуальные hover эффекты
                    // но НЕ закрывать expanded меню на hover кнопок
                  }}
                  onHoverOut={() => {
                    setButtonHovered((prev) => ({ ...prev, [button.text]: false }));
                  }}
                />
              );
            })}
        </>
      )}

      <View style={{ flex: 1, flexDirection: "row-reverse", marginRight: 40 * scaleAll }}>
        <PressableWrap onPress={() => refSearchBarTop.current?.enable()}>
          <Search size={(isMediumVersion ? 22 : 25) * scaleAll} />
        </PressableWrap>
      </View>

      <SearchBarTop
        ref={refSearchBarTop}
        onClose={() => {}}
        navigation={navigation}
        callBackOnPress={() => {
          refExpandedMenu.current?.close();
        }}
      />

      <SlideOutMenu options={options} ref={refSlideOutMenu} setServiceMobile={setServiceMobile} />

      <ExpandedMenu ref={refExpandedMenu} />
    </Pressable>
  );
});

export default React.memo(TopNavigator);
